import { render } from "./InputCaracterItem.vue?vue&type=template&id=8077ef44&scoped=true"
import script from "./InputCaracterItem.vue?vue&type=script&lang=js"
export * from "./InputCaracterItem.vue?vue&type=script&lang=js"

import "./InputCaracterItem.vue?vue&type=style&index=0&id=8077ef44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8077ef44"]])

export default __exports__